<template>
  <Auth :auth="auth">
    <template v-slot:default>
      <el-button v-bind="$attrs" v-on="$listeners">
        <slot></slot>
      </el-button>
    </template>

    <template v-slot:denied v-if="denied">
      <el-button v-bind="$attrs" v-on="$listeners" v-if="auth">
        <slot></slot>
      </el-button>
    </template>
  </Auth>
</template>

<script>
  import Auth from './Auth'
  export default {
    name: 'l-auth-button',
    components: {
      Auth
    },
    props: {
      auth: {
        type: String,
        required: true
      }
    }
  }
</script>